module.exports = __webpack_public_path__ + "img/chraoy-chongvar-branch.cdc2c9d4.jpg";